

































import Vue from 'vue'
import DefaultCss from './defaultcss'
import EmojiText from '@/components/EmojiText'
import './InstagramElement.scss'

export default Vue.extend({
  name: 'InstagramElement',
  props: {
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    css: {
      type: Object,
      required: true
    },
    numbers: {
      type: Object,
      required: false
    },
    instagram: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    defaultcss: DefaultCss,
    font: 'Dancing Script',
    isLandscape: true,
    isOverflowing: false,
    imageLoaded: false
  }),
  watch: {
    // listen to draggableBox changes
    numbers: function (newRect) {
      this.isLandscape = newRect.width >= newRect.height
    },
    width: function (newWidth) {
      this.isLandscape = newWidth >= this.height
    }
  },
  beforeMount () {
    this.isLandscape = this.width >= this.height
  },
  mounted () {
    this.checkTextOverflow()
    setTimeout(() => this.imageLoaded = true, 1000)
  },
  updated () {
    this.checkTextOverflow()
  },
  computed: {
    instagramClass (): any {
      return {
        landscape: this.isLandscape
      }
    },
    // background
    backgroundstyle (): any {
      return {
        'background-color': this.getValue('text', 'visible') ? this.getValue('background', 'color') : 'transparent',
        'border-radius': (this.showText) ? this.getPixelSize('largest', 'background', 'borderradius') + 'px' : 0
      }
    },
    imagestyle (): Partial<CSSStyleDeclaration> {
      const mediaShouldCover = !!this.getValue('media', 'cover')
      const mediaSize = (mediaShouldCover)  ? 'cover' : 'contain'
      // FIXME(tcuypers) For some reason the line below is not working anymore
      let mediaWidth = (this.showText && this.isLandscape) ? 'max-content' : '100%'
      if (!this.imageLoaded) {
        mediaWidth = '0%'
      }
      const style: Partial<CSSStyleDeclaration> = {
        backgroundImage: 'url(' + this.instagramImage + ')',
        backgroundSize: mediaSize,
        backgroundColor: this.getValue('background', 'color'),
        width: mediaWidth,
        borderRadius: (this.showText) ? '0px' : this.getPixelSize('largest', 'background', 'borderradius') + 'px'
      }
      return style
    },
    instagramImage (): string {
      if (this.instagram && this.instagram.data && this.instagram.data.media_url) {
        return this.instagram.data.media_url
      }
      return ''
    },
    instagramText (): string {
      if (this.instagram && this.instagram.data && this.instagram.data.text) {
        return this.instagram.data.selectedText || this.instagram.data.text
      }
      return ''
    },
    // username
    username (): string {
      if (this.instagram && this.instagram.data && this.instagram.data.user && this.instagram.data.user.name) {
        const username = this.instagram.data.user.name
        return this.removeEmojis(username)
      }
      return ''
    },
    showText (): boolean {
      return !!this.getValue('text', 'visible')
    },
    usernameStyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        color: this.getValue('username', 'color'),
        marginTop: this.getPixelSize('height', 'username', 'top') + 'px',
        font: this.getValue('username', 'font'),
        fontFamily: this.getFontFamily('username', 'font'),
        fontSize: this.getPixelSize('largest', 'username', 'fontsize') / 3 + 'px'
      }
      return style
    },
    textstyle (): Partial<CSSStyleDeclaration> {
      const fontSize = this.getPixelSize('largest', 'text', 'fontsize') / 3
      const lineHeight = fontSize * 1.20

      const style: Partial<CSSStyleDeclaration> = {
        display: 'inline-flex',
        color: this.getValue('text', 'color'),
        font: this.getValue('text', 'font'),
        fontFamily: this.getFontFamily('text', 'font'),
        fontSize: fontSize+ 'px',
        lineHeight: lineHeight + 'px'
      }
      return style
    },
    emojiTextstyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        marginTop: this.getPixelSize('height', 'text', 'top') + 'px',
      }
      return style
    },
    overflowStyle (): Partial<CSSStyleDeclaration> {
      const bgColor = this.getValue('background', 'color')
      const fontSize = this.getPixelSize('largest', 'username', 'fontsize')

      const style: Partial<CSSStyleDeclaration> = {
        paddingBottom: `${fontSize}px`,
        background: (this.isOverflowing) ? `linear-gradient(0deg, ${bgColor} 15%, rgba(255,255,255,0) 60%)` : 'transparent',
        fontFamily: this.getFontFamily('text', 'font'),
        fontSize: this.getPixelSize('largest', 'text', 'fontsize') / 2 + 'px',
        height: fontSize * 1.5 + 'px'
      }
      return style
    }
  },
  methods: {
    getValue (component: string, tag: string) {
      let value = (this.defaultcss[component] && this.defaultcss[component][tag])
      if (value === undefined) {
        console.error(`Default CSS for ${component} / ${tag} not existing`)
        value = 0
      }
      if (this.css && this.css[component] && this.css[component][tag] !== undefined) {
        value = this.css[component][tag]
      }
      return value
    },
    getPixelSize (direction, component, tag) {
      const value = this.getValue(component, tag)
      if (direction === 'largest') return Math.max(this.height, this.width) * value / 100
      if (direction === 'width') return this.width * value / 100
      if (direction === 'height') return this.height * value / 100
      return 0
    },
    removeEmojis (text) {
      const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
      return text.replace(regex, '')
    },
    getFontFamily (component, tag) {
      const font = this.getValue(component, tag)
      if (font) {
        return font + ', Work Sans, Helvetica, Arial, sans-serif'
      }
      return 'Work Sans, Helvetica, Arial, sans-serif'
    },
    checkTextOverflow () {
      const container = this.$refs.textContainer as HTMLElement
      const emojiText = this.$refs.emojiTextContainer as HTMLElement

      if (this.showText && container && emojiText) {
        this.isOverflowing = emojiText.offsetHeight > container.offsetHeight
      }
    }
  },
  components: {
    EmojiText
  }
})
